import PlateFeederSH_primary from './Plate-feeder-SH-primary.png';
import PlateFeederSH_secondary from './Plate-feeder-SH-secondary.png';
import PlateFeederSH_primary2 from './Plate-feeder-SH-primary_2.png';
import PlateFeederSH_secondary2 from './Plate-feeder-SH-secondary_2.png';

export const getImagePlateFeeder = (modelName: string) => {
  if (
    modelName.slice(-1) === '5' ||
    (modelName.slice(-1) === 'M' && modelName.slice(-2) === '5')
  ) {
    return PlateFeederSH_secondary;
  }
  return PlateFeederSH_primary;
};

export const getImagePlateFeeder2 = (modelName: string) => {
  if (
    modelName.slice(-1) === '5' ||
    (modelName.slice(-1) === 'M' && modelName.slice(-2) === '5')
  ) {
    return PlateFeederSH_secondary2;
  }
  return PlateFeederSH_primary2;
};
